import { render } from "./Index_index.vue?vue&type=template&id=47b70332&scoped=true"
import script from "./Index_index.vue?vue&type=script&lang=js"
export * from "./Index_index.vue?vue&type=script&lang=js"

import "./Index_index.vue?vue&type=style&index=0&id=47b70332&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47b70332"

export default script